import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { commonPostPutApi } from "../../redux/reducers/commonApiSlice";
import { showConfirmAlert } from "../components-react/ReactAlert";
import Loader from "../ui/Loader";
import {
  verify_discount_payment_request,
  verify_discount_pt_payment_request,
} from "../../data/ApiEndpoints";
import ViewDetails from "./ViewDetails";

const DPApproval = ({ userInfoData, rowData, callFunction, onCloseModal }) => {
  const dispatch = useDispatch();
  const { postPutLoading1 } = useSelector((state) => state.common);

  const isClusterManager = userInfoData?.account_type === "cluster_manager";

  const isPT = rowData?.type === "addon_pt";
  const isNotEmail = userInfoData?.email !== "vn@wtfgyms.com";

  const forminitials = {
    description: "",
  };
  const [formValues, setFormValues] = useState(forminitials);
  const [formErrors, setFormErrors] = useState({});

  const validateForm = (formValues, isReject) => {
    let errors = {};

    if ((isNotEmail || isReject) && !formValues.description) {
      errors.description = "required!";
    }

    return errors;
  };

  const handleSubmitForm = async (payload, endpoint) => {
    const method = "POST";
    // const endpoint = verify_discount_payment_request;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setFormValues(forminitials);
        callFunction();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const onSubmit = (isReject) => {
    const errors = validateForm(formValues, isReject);
    setFormErrors(errors);

    if (Object.keys(errors)?.length === 0) {
      const userData = {
        request_id: rowData?.uid || "",
        approval_status: isReject ? "rejected" : "approved",
        aprv_rej_remarks: formValues.description || "",
        is_cm_approval: isClusterManager ? true : false,
      };

      const handleConfirm = async () => {
        handleSubmitForm(
          userData,
          isPT
            ? verify_discount_pt_payment_request
            : verify_discount_payment_request
        );

        onCloseModal();
      };

      showConfirmAlert(
        handleConfirm,
        isReject
          ? "Are you sure you want to reject this request?"
          : "Are you sure you want to approve this request?",
        "No, Cancel",
        "Yes, Submit Form"
      );
    }
  };

  return (
    <>
      <ViewDetails rowData={rowData} isApproval={true} />

      <form className="formContainer mb15">
        <div className="formInputsGrid oneGridSystem">
          <div className="formInputBox span4">
            <label htmlFor="description" className="formInputLabel">
              Enter remarks{" "}
              <small>
                (Remarks is mandatory if rejecting){" "}
                {formErrors.description || isNotEmail ? (
                  <span className="required">*</span>
                ) : null}
              </small>
            </label>

            <textarea
              name="description"
              className={`formInput ${
                formErrors.description ? "formError" : ""
              }`}
              style={{
                background: "#fff",
                minHeight: "150px",
              }}
              placeholder="Enter Remarks"
              value={formValues.description || ""}
              onChange={(e) =>
                setFormValues((prevs) => ({
                  ...prevs,
                  description: e.target.value,
                }))
              }
            ></textarea>
          </div>
        </div>

        <div className="formButtons" style={{ justifyContent: "flex-end" }}>
          {postPutLoading1 ? (
            <Loader />
          ) : (
            <>
              <Button
                className="saveBtn"
                variant="primary"
                onClick={() => onSubmit(false)}
              >
                approve
              </Button>
              <Button
                className="saveBtn"
                variant="danger"
                onClick={() => onSubmit(true)}
              >
                reject
              </Button>
            </>
          )}
        </div>
      </form>
    </>
  );
};

export default DPApproval;
